import Cookies from "universal-cookie";

export const cookies = new Cookies(null, {
  // note: default set options
  path: "/",
  domain: process.env.REACT_APP_COOKIE_DOMAIN,
});

export const setAccessCookie = (
  key = "token",
  token,
  option = {
    // note: option sample.
    // path: "/",
    // sameSite: "strict",
    // secure: true,
    // maxAge: 15 * 60, // 15 min
  },
) => {
  cookies.set(key, token, option);
};

export const getAccessCookie = (token = "token") => cookies.get(token) || null;

export const removeAccessCookie = (
  key = "token",
  option = { path: "/", domain: process.env.REACT_APP_COOKIE_DOMAIN },
) => cookies.remove(key, option);

export function removeCookies(
  names = [],
  options = { path: "/", domain: process.env.REACT_APP_COOKIE_DOMAIN },
) {
  if (!Array.isArray(names)) {
    console.warn("Expected an array of cookie names.");
    return;
  }

  names.forEach((name) => {
    cookies.remove(name, options);
  });
}
